import { Link } from "react-router-dom";
import logoImg from "@/assets/bodyhackguide-logo.webp";

/**
 * The logo and wordmark that start the navbar and the phone menu. The navbar outline in index.html (.shell-nav)
 * draws the same box with the same classes before any script runs, so keep the two in step: change the size,
 * gap or wordmark here and change it there, or the logo jumps when React takes over.
 */
export default function SiteLogo({ onClick, priority = false }: { onClick?: () => void; priority?: boolean }) {
  return (
    // 44px tall for the touch rule; the logo inside stays centred in the bar exactly as the outline draws it.
    <Link to="/" onClick={onClick} aria-label="BodyHackGuide home" className="flex h-11 shrink-0 items-center gap-2 rounded-control">
      <img
        src={logoImg}
        alt=""
        width={32}
        height={32}
        decoding="async"
        className="h-7 w-7 rounded-lg object-contain lg:h-8 lg:w-8"
        // fetchpriority in lower case: React 18.3 rejects the camelCase prop on a plain img.
        {...(priority ? ({ fetchpriority: "high" } as Record<string, string>) : {})}
      />
      <span className="text-sm font-bold tracking-tight text-gradient-primary sm:text-base lg:text-lg">BodyHackGuide</span>
    </Link>
  );
}
